// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3CZrl","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1P9Dp"};